import { useMutation, useQueryClient } from "react-query";
import { AuthContext } from "../../Context/AuthContext";
import { useContext } from "react";

const createBusinessCategory = async (categoryData, token) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/categories/createcategory`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(categoryData),
    }
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to create business category");
  }

  return response.json();
};

const useCreateBusinessCategory = () => {
  const queryClient = useQueryClient();
  const { token } = useContext(AuthContext);

  return useMutation((categoryData) => createBusinessCategory(categoryData, token), {
    onSuccess: () => {
      queryClient.invalidateQueries("businessCategories");
    },
  });
};

export default useCreateBusinessCategory;
